import { render, staticRenderFns } from "./BookingTabs.vue?vue&type=template&id=4a97d375&"
import script from "./BookingTabs.vue?vue&type=script&lang=js&"
export * from "./BookingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports